<template>
  <div>
    <BaseLabel :text="label" :class="{ 'mb-2': !description }"></BaseLabel>
    <p
      v-if="description"
      class="d-flex align-left flex-no-wrap font-14 description"
    >
      {{ description }}
    </p>
    <div :class="className">
      <BaseAddressLookup
        :rules="rules"
        :loading="loading"
        :placeholder="
          $vuetify.breakpoint.lgAndUp
            ? 'Start typing your address or postcode...'
            : 'Start typing...'
        "
        :data-uiid="dataUiid"
        :hideDetails="hideDetails"
        v-model="addressForm.findProperty.Value"
        @address-selected="addressSelected"
        @click:clear="onClear()"
        @keyup.delete="onClear()"
        @enter-address-manually="enterManually"
        ref="autocomplete"
      />
    </div>
  </div>
</template>

<script>
import { generateAddress, loqateEntriesToList } from "@/common/addresses";
import BaseAddressLookup from "@/components/BaseComponents/BaseAddressLookup.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import { formatAddress } from "@/common/addresses";
export default {
  name: "InputFindProperty",
  components: {
    BaseLabel,
    BaseAddressLookup,
  },
  props: {
    isShowCardPropertyDetails: Boolean,
    addressForm: Object,
    loading: Boolean,
    rules: Object,
    dataUiid: String,
    hideDetails: [Boolean, String],
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
  },
  computed: {
    propertyDataLoading() {
      return this.loading ? "info" : false;
    },
    items() {
      return loqateEntriesToList(this.entries);
    },
  },
  watch: {
    search(val) {
      this.isLoading = true;
      this.searchAddressDebounced(val);
    },
  },
  methods: {
    addressSelected(response) {
      const item = response.data.Items[0];
      const propertiesAddress = formatAddress(item);
      const selectedAddress = {
        ["PostCode"]: item.PostalCode,
        ["Street"]: propertiesAddress.street,
        ["District"]: propertiesAddress.district,
        ["Town"]: item.City,
        ["County"]: item.Province,
      };

      // remove duplicate address values
      selectedAddress.County =
        selectedAddress.Town === selectedAddress.County
          ? ""
          : selectedAddress.County;

      // remove duplicate address values
      selectedAddress.District =
        selectedAddress.Street === selectedAddress.District
          ? ""
          : selectedAddress.District;

      const street = selectedAddress.Street;
      const town = selectedAddress.Town;
      const postcode = selectedAddress.PostCode;
      const displayAddress = generateAddress(street, town, postcode);

      this.addressForm.findProperty.Value = displayAddress;
      this.addressForm.postCode.Value = selectedAddress.PostCode;
      this.addressForm.street.Value = selectedAddress.Street;
      this.addressForm.district.Value = selectedAddress.District;
      this.addressForm.town.Value = selectedAddress.Town;
      this.addressForm.county.Value = selectedAddress.County;

      this.$emit("addressSelected", selectedAddress);
    },
    onClear() {
      this.addressForm.findProperty.Value = null;
      this.$emit("clear");
    },
    enterManually() {
      this.addressForm.findProperty.Value = null;
      this.$refs.autocomplete.isMenuActive = false;
      this.$emit("toggleManual");
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  letter-spacing: 0.4px;
  margin-bottom: 13px;
  max-width: 665px;
  color: #272727;
}
</style>
